import { createTheme, SxProps } from '@mui/material';

/**
 * Material UI styles for the DateTimePicker components
 */
export const dateTimePickerMuiStyles: SxProps = {
  '& .MuiInputBase-input': {
    color: 'white',
    fontFamily: 'var(--font-oxanium)'
  },
  '& .MuiInputLabel-root': {
    color: 'white',
    fontFamily: 'var(--font-oxanium)'
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'gray'
  },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: 'white'
  },
  '& .MuiSvgIcon-root': {
    color: 'white'
  },
  '& .MuiPickersPopper-root': {
    zIndex: 1002,
    '& .MuiTypography-root': {
      fontFamily: 'var(--font-oxanium)'
    },
    '& .MuiPickersDay-root': {
      fontFamily: 'var(--font-oxanium)'
    }
  }
};

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#3f51b5'
    },
    background: {
      paper: '#0D0F1F',
      default: '#0D0F1F'
    },
    text: {
      primary: '#fff',
      secondary: 'rgba(255, 255, 255, 0.7)'
    }
  }
});
